export const CREATE_LANE = 'CREATE_LANE';
export const UPDATE_LANE = 'UPDATE_LANE';
export const DELETE_LANE = 'DELETE_LANE';
export const ATTACH_TO_LANE = 'ATTACH_TO_LANE';
export const DETACH_FROM_LANE = 'DETACH_FROM_LANE';
export const MOVE_LANE = 'MOVE_LANE';

export const MOVE_NOTE = 'MOVE_NOTE';
export const CREATE_NOTE = 'CREATE_NOTE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const DELETE_NOTE = 'DELETE_NOTE';



/** WEBPACK FOOTER **
 ** ./src/kanban2/constants/actionTypes.js
 **/